import React, { useState } from 'react'
import { ReactComponent as FilterSVG } from '../../resouces/svg/filter.svg'
import {useNavigate} from 'react-router-dom'

import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ComfirmModalComponent from '../../component/ui_component/confirm.modal';
import TableComponent from '../../component/ui_component/table';

function PurchaseOrderList(props) {
    const {setActionType} = props

    const navigation = useNavigate()
    const [deleteOrder, setDeleteOrder] = useState({modal: false, selected_details: {}})
  
    const columns = [
      {
        name: 'S.NO',
        selector: (row, index) => index + 1,
      },
      {
        name: 'ORDER NO',
        selector: row => row.order_no,
      },
      {
        name: 'VENDOR NAME',
        selector: row => row.vendor_no,
      },
      {
        name: 'ORDER STATUS',
        selector: row => row.order_status,
      },
      {
        name: 'PAYMENT STATUS',
        selector: row => row.payment_status,
      },
      {
        name: 'ACTION',
        selector: row => (
          <>
            <IconButton onClick={() => {
              NavigationHandler(`/purchase-order/${'937392'}/details`)
            }}>
              <VisibilityIcon style={{ color: 'rgba(0,0,0,0.3)', size: '7px' }} />
            </IconButton>
            <IconButton onClick={() => {
              toggle_delete_order()  
            }}>
              <DeleteOutlineIcon style={{ color: 'rgba(255,0,0,0.5)', size: '5px' }} />
            </IconButton>
          </>
        )
      }
    ];
  
    const toggle_delete_order = () => {
      setDeleteOrder({modal: !deleteOrder.modal, ...setDeleteOrder.selected_details})
    }
  
    const delete_order = (payload) => {
      console.log(payload, 'payload')
    }
  
    const NavigationHandler = (url) => {
      navigation(url)
    }
  
    const docs = [
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "Partially Paid"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "Paid"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      },
      {
        order_no: '001',
        vendor_no: "kathiravan",
        order_status: "pending",
        payment_status: "pending"
      }
    ]
    return (
      <div className='flex flex-col h-full p-5 pt-0'>
        <div className='flex items-center justify-between h-10 mb-2'>
          <div className='font-roboto font-bold'>Purchase Order List</div>
          <div>
            <button class="font-roboto bg-theme_color-600 hover:bg-theme_color-700 text-white text-sm py-1 px-4 border border-theme_color-700 rounded mr-2" type="button" onClick={() => NavigationHandler(`/purchase-order/add`)}>
              Add New
            </button>
            <IconButton type="button" deleteOrder >
              <FilterSVG style={{ color: "rgba(0,0,0,0.3)" }} />
            </IconButton>
          </div>
        </div>
        <div className='flex-grow pb-4'>
          <TableComponent
            column={columns}
            docs={docs}
          />
          <ComfirmModalComponent setProperty={toggle_delete_order} modal={deleteOrder.modal}/>
        </div>
      </div>
    )
}

export default PurchaseOrderList